import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRechten } from "../context/RechtenContext";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "../components/ui/dialog";
import { Button } from "../components/ui/button";
import config from "../config";   // 🔑 toegevoegd
import TerugNaarHomeButton from "../components/ui/TerugNaarHomeButton";
export default function Feedback() {
  const { rechten } = useRechten();
  const [feedback, setFeedback] = useState("");
  const [open, setOpen] = useState(false);
  const [sending, setSending] = useState(false);
  const navigate = useNavigate();

  const displayName = rechten?.DisplayName || "Onbekend";
  const upn = rechten?.UPN || "Onbekend";
  const tenantId = rechten?.TenantID || "Onbekend";

  const verstuurFeedback = async () => {
    setSending(true);
    try {
      const token = sessionStorage.getItem("access_token");
      await fetch(`${config.API_URL}/feedback`, {   // 🔑 aangepast
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          displayName,
          upn,
          tenantId,
          feedback,
        }),
      });

      alert("✅ Feedback succesvol verstuurd!");
      setFeedback("");
      setOpen(false);
      navigate("/");
    } catch (err) {
      console.error("❌ Fout bij versturen feedback:", err);
      alert("❌ Er ging iets mis bij het versturen van de feedback.");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="max-w-3xl mx-auto bg-white shadow-xl rounded-2xl p-8 space-y-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-4">
        Feedback & suggesties
      </h1>
      <p className="text-gray-600">
        Op deze pagina kunt u alles melden met betrekking tot de functionaliteit
        van het klantportaal. Of het nu gaat om een foutmelding, een verbetering
        of een nieuw idee.
      </p>

      <div className="space-y-2">
        <p><strong>Naam:</strong> {displayName}</p>
        <p><strong>Email:</strong> {upn}</p>
        <p><strong>TenantID:</strong> {tenantId}</p>
      </div>

      <div>
        <label
          htmlFor="feedback"
          className="block text-sm font-medium text-gray-700"
        >
          Uw feedback
        </label>
        <textarea
          id="feedback"
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
          className="w-full mt-2 border rounded-lg p-3 text-gray-700 shadow-sm focus:ring focus:ring-blue-200"
          rows={5}
          placeholder="Beschrijf hier uw idee of probleem..."
        />
      </div>

      <Button
        onClick={() => setOpen(true)}
        disabled={!feedback.trim()}
        className="w-full bg-blue-600 text-white hover:bg-blue-700"
      >
        Verstuur
      </Button>

      <TerugNaarHomeButton />

      {/* Bevestiging popup */}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Bevestig uw feedback</DialogTitle>
          </DialogHeader>
          <p className="mb-4">
            Wilt u de volgende feedback versturen naar het NGW-team?
          </p>
          <div className="bg-gray-100 p-4 rounded-lg text-sm text-gray-700">
            <p><strong>Naam:</strong> {displayName}</p>
            <p><strong>Email:</strong> {upn}</p>
            <p><strong>TenantID:</strong> {tenantId}</p>
            <p className="mt-2"><strong>Feedback:</strong></p>
            <p>{feedback}</p>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>
              Annuleren
            </Button>
            <Button
              onClick={verstuurFeedback}
              disabled={sending}
              className="bg-blue-600 text-white hover:bg-blue-700"
            >
              {sending ? "Bezig..." : "Bevestigen & versturen"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
